@if ({
  residentAccess: residentAccess$ | async,
  expired: licenseExpired$ | async,
  brand: brand$ | async
}; as vm) {
  <ion-app swipe
    [ngStyle]="vm.brand"
    (previous)="onSwipeBack()">
    <div id="main-content"
      class="ion-page">
      <ion-tabs>
        @if (isLogged() && role() != null && !['registered', ''].includes(role()) && !vm.expired && vm.residentAccess) {
          <ion-tab-bar slot="bottom"
            color="primary">
            @if (!hideTabs.includes(role())) {
              <ion-tab-button tab="home"
                (click)="onHome()">
                <ion-icon name="home"
                  aria-hidden="true"></ion-icon>
                <ion-label>{{ 'nav.home' | translate }}</ion-label>
              </ion-tab-button>
              <ion-tab-button tab="worker/sites"
                (click)="onSites()">
                <ion-icon name="business"
                  aria-hidden="true"></ion-icon>
                @if (role() === 'resident') {
                  <ion-label> {{ 'nav.residence' | translate }}</ion-label>
                } @else {
                  <ion-label> {{ 'nav.sites' | translate }}</ion-label>
                }
              </ion-tab-button>
              <ion-tab-button tab="worker/tickets"
                (click)="onTickets()">
                <ion-icon name="albums"
                  aria-hidden="true"></ion-icon>
                <ion-label> {{ 'nav.tickets' | translate }}</ion-label>
              </ion-tab-button>
            }
            <ion-tab-button (click)="onMenu()">
              <ion-icon class="help"
                name="apps"
                aria-hidden="true"></ion-icon>
              <ion-label> {{ 'nav.menu' | translate }}</ion-label>
            </ion-tab-button>
          </ion-tab-bar>
        }
      </ion-tabs>
    </div>
  </ion-app>
}